<template>
  <div class="manage-members">
    <router-view />
    <div class="d-flex align-items justify-content-between">
      <SearchBar
        style="padding: 0; width: 100%; margin-right: 20px;"
        @search="handleSearchMember"
      />
      <ActionButton
        label="Add Member"
        :theme="{ primary, secondary, event, danger }"
        @customEvent="handleAddMemberClick"
        style="margin-top: 0; width: auto; line-height: 16px;"
      />
    </div>
    <div class="content--main" v-if="members && members.data">
      <div class="table-wrapper" v-if="members.data.length == 0">
        <span class="">No results found</span>
      </div>
      <div class="table-wrapper" v-else>
        <div class="table-header d-flex justify-content-between w-100">
          <span>Manage members</span>
          <div class="table__control d-flex align-items-center">
            <span class="mb-0 mr-3" v-if="members.meta"
              >{{ currentPage }} to {{ currentTotal }} of
              {{ members.meta.totalCount }}</span
            >
            <div
              class="table__nav d-flex align-items-center"
              v-if="members.links"
            >
              <button
                class="btn__nav--prev btn__nav"
                v-if="members.links.prev"
                :style="{ 'background-color': secondary }"
                @click="fetchMembers(members.links.prev)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5"
                  height="7.688"
                  viewBox="0 0 5 7.688"
                >
                  <path
                    d="M285.983,372.7l-3.8-3.8,1.114-1.114,2.688,2.688,2.771-2.772,1.114,1.114Z"
                    transform="translate(372.701 -282.181) rotate(90)"
                    :fill="primary"
                  />
                </svg>
              </button>
              <button
                class="btn__nav--next btn__nav"
                :style="{ color: primary, 'background-color': secondary }"
                v-if="members.links.next"
                @click="fetchMembers(members.links.next)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5"
                  height="7.688"
                  viewBox="0 0 5 7.688"
                >
                  <path
                    d="M285.983,372.7l-3.8-3.8,1.114-1.114,2.688,2.688,2.771-2.772,1.114,1.114Z"
                    transform="translate(-367.701 289.869) rotate(-90)"
                    :fill="primary"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <Datatable
          v-if="members"
          :headers="headers"
          key="dt-members"
          class="dt-members px-30 pb-30"
        >
          <tr v-for="member in members.data" :key="member.id">
            <td>{{ firstLetterUpperCase(member.lastName) }}</td>
            <td>{{ firstLetterUpperCase(member.firstName) }}</td>
            <td>{{ member.email }}</td>
            <td>
              <span
                class="font-weight-normal"
                :class="[
                  'member.status === 0' ? 'text-success' : 'text-danger'
                ]"
                >{{ member.status === 0 ? "Active" : "Inactive" }}</span
              >
            </td>
            <td class="text-right table__actions-wrapper">
              <button @click="toggleOptions(member.id)">
                <img
                  src="~@/assets/media/icons/more_options.svg"
                  alt="more options"
                />
              </button>
              <div
                class="table__action-dropdown"
                v-if="openedOption.includes(member.id)"
              >
                <ul>
                  <li @click="handleAddBooking(member.id)">
                    <img src="~@/assets/media/icons/add.svg" alt="add icon" />
                    Add Booking
                  </li>
                  <li @click="handleViewBooking(member)">
                    <img
                      src="~@/assets/media/icons/calendar_a.svg"
                      alt="view icon"
                    />
                    View Booking
                  </li>
                  <li @click="handleEditMemberClick(member)">
                    <img
                      src="~@/assets/media/icons/create.svg"
                      alt="edit icon"
                    />
                    Edit User
                  </li>
                  <li @click="handleChangePassword(member)">
                    <img
                      src="~@/assets/media/icons/create.svg"
                      alt="edit icon"
                    />
                    Change Password
                  </li>
                  <li @click="handleDeactivate(member)">
                    <img
                      src="~@/assets/media/icons/deactivate.svg"
                      alt="deactivate icon"
                    />
                    Deactivate
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </Datatable>

        <Spinner v-else />
      </div>
    </div>
    <Spinner v-else :style="{ 'margin-top': '40px' }" :theme="primary" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar";
import ActionButton from "@/components/ActionButton";
import Datatable from "@/components/Datatable";
import Spinner from "@/components/Spinner";
import { mixin as clickaway } from "vue-clickaway";
import axios from "@/helpers/axios";
import { socketSender } from "@/helpers/socket";

export default {
  mixins: [clickaway],
  name: "AdminManageMembers",
  components: {
    SearchBar,
    ActionButton,
    Datatable,
    Spinner
  },
  data: () => ({
    apiOptions: {
      mode: "pagination",
      link: null,
      queryParams: "orderBy=lastName:ASC"
    },
    headers: [
      {
        _id: 0,
        label: "Last Name"
      },
      {
        _id: 1,
        label: "First Name"
      },
      {
        _id: 2,
        label: "Email"
      },
      {
        _id: 3,
        label: "Status"
      },
      {
        _id: 4,
        label: "Actions"
      }
    ],
    currentTotal: null,
    currentPage: null,
    // members: null,
    isOpened: false,
    openedOption: []
  }),
  computed: {
    members() {
      return this.$store.state.concierge.userList;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  async created() {
    await this.$store.dispatch("fetchUsers", this.apiOptions);
    this.setPageCounter();
  },
  methods: {
    setPageCounter() {
      if (this.members && this.members.links) {
        let currentPage = parseInt(
          this.members.links.self.split("page[number]=")[1]
        );

        this.currentPage = currentPage * 10 - 9;
        this.currentTotal =
          this.members.meta.totalCount > currentPage * 10
            ? parseInt(currentPage) * 10
            : this.members.meta.totalCount;
      }
    },
    handleAddBooking(memberId) {
      this.$router.push({
        name: `admin-booking`,
        params: { id: memberId }
      });
    },
    handleAddMemberClick() {
      this.$emit("showModal", { name: "add-member" });
    },
    handleChangePassword(member) {
      let modal = `admin-${this.$route.name}-add-member`;
      let name = "change-password";
      let singleRecord = member;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    async fetchMembers(links) {
      if (links) {
        this.apiOptions.link = links;
        await this.$store.dispatch("fetchUsers", this.apiOptions);
        this.setPageCounter();
      }
    },
    toggleOptions(id) {
      const index = this.openedOption.indexOf(id);
      if (index > -1) {
        this.openedOption = [];
      } else {
        this.openedOption = [];
        this.openedOption.push(id);
      }
    },
    async handleDeactivate(member) {
      let userOrder = await axios
        .get(`/users/${member.id}/orders`)
        .then(result => {
          return result.data;
        });
      if (userOrder.data.count != 0) {
        this.$swal({
          title: "Member has bookings. Can't deactivate member.",
          type: "error"
        });
      } else {
        this.$swal({
          title: "Do you want to deactivate this member?",
          type: "warning",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true
        }).then(async result => {
          if (result.value == true) {
            await this.$store.dispatch("removeMember", member.id);
            await this.$store.dispatch("fetchUsers", this.apiOptions);
            /**
             * SOCKET: Deactivate member
             */
            socketSender(
              "updateLog",
              `${this.$store.getters.getFullUser} deactivated the user ${member.firstName} ${member.lastName}`
            );
            this.activeIndex = this.activeIndex == 0 ? 0 : this.activeIndex - 1;
            this.setPageCounter();
          }
        });
      }
    },
    handleEditMemberClick(member) {
      let modal = `admin-${this.$route.name}-add-member`;
      let name = "edit-member";
      let singleRecord = member;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    handleViewBooking(member) {
      this.$router.push({
        name: "admin-member-profile",
        params: { id: member.id }
      });
    },
    async handleSearchMember(searchTerm) {
      if (searchTerm != null && searchTerm != "") {
        await this.$store.dispatch("searchUsers", searchTerm);
      } else {
        await this.$store.dispatch("fetchUsers", this.apiOptions);
      }
      this.setPageCounter();
    },
    firstLetterUpperCase(str) {
      if (typeof str !== "string") return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-members {
  padding: 0 15px;
  .content--main {
    height: calc(100vh - 221px);
    overflow-x: hidden;
    overflow-y: auto;
    .dt-members {
      overflow: auto;
    }
  }
  .searchbar > .form-group {
    margin: 0;
  }
  .table-wrapper {
    background-color: $gray-50;
    margin-bottom: 40px;
    margin-top: 40px;
    span {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-xs;
      margin-bottom: 20px;
    }
    .table__nav {
      button {
        background-color: $brand-secondary;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        display: block;
        height: 32px;
        margin-right: 10px;
        width: 32px;
      }
    }
    .table__actions-wrapper {
      position: relative;
      button {
        background-color: transparent;
        border-radius: 50%;
        border: none;
        display: block;
        margin-left: auto;
        height: 23px;
        transition: all 0.3s ease;
        width: 23px;
        &:hover {
          background-color: $gray-250;
        }
      }
      .table__action-dropdown {
        animation: fade-in-down 0.2s ease-out forwards;
        background-color: $white;
        border-radius: 5px;
        box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.1);
        text-align: left;
        position: absolute;
        right: 0;
        width: 200px;
        z-index: 1;
        ul {
          list-style-type: none;
          margin-bottom: 0;
          padding: 0;
          li {
            align-items: center;
            color: $gray-900;
            cursor: pointer;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-xs;
            padding: 10px 25px;
            transition: all 0.3s ease-in;
            &:last-child {
              color: #ea1b00;
              margin-bottom: 0;
            }
            img {
              margin-right: 15px;
            }
            &:hover {
              background-color: $gray-250;
            }
          }
        }
      }
    }
  }
  .table-header {
    padding: 30px 30px 0;
  }
}

@keyframes fade-in-down {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
